import { useState, useCallback, useRef } from 'react';

/**
 * useToast — manages a list of toast notifications.
 *
 * @returns {{ toasts, addToast, removeToast }}
 */
export const useToast = () => {
  const [toasts, setToasts] = useState([]);
  const timeoutRefs = useRef({});

  const removeToast = useCallback((id) => {
    setToasts(prev => prev.filter(t => t.id !== id));
    if (timeoutRefs.current[id]) {
      clearTimeout(timeoutRefs.current[id]);
      delete timeoutRefs.current[id];
    }
  }, []);

  const addToast = useCallback((message, type = 'info', duration = 3000) => {
    // Use timestamp + random to avoid ID collisions for rapid successive toasts
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);

    if (duration > 0) {
      timeoutRefs.current[id] = setTimeout(() => {
        setToasts(prev => prev.filter(t => t.id !== id));
        delete timeoutRefs.current[id];
      }, duration);
    }

    return id;
  }, []);

  return { toasts, addToast, removeToast };
};
